import { PageHeader, EmptyContent } from "@/common";
import { AppScope } from "@/common/AppScope";

export const BuildPage = ({ name, children = null }) => {
  return (
    <div className="flex flex-col flex-1 w-full h-full overflow-y-auto p-8 pb-0">
      <AppScope />
      <PageHeader title={name} scope />
      {children ? children : <EmptyContent messages={["Add your first documents..."]} />}
    </div>
  );
};
